export default __webpack_public_path__ + "static/media/unit-result-4.0b650e8f.mp3";